module.exports = __webpack_public_path__ + "media/images/order_btn_ov-e249cd5f959ea88aa0b11d6c34fd4ffc.gif";